import { Component, Schema } from "minecs";

@Component()
export class DoNotEject extends Schema {}
